import { css } from 'emotion'

export const StripeInvoiceCardStyles = css`
  display: flex;
  justify-content: space-between;
`
